import { Toaster as SonnerToaster, type ToasterProps } from 'sonner'

/**
 * Toaster baseado no Sonner — toast system oficial conforme §15 da spec.
 *
 * O tema (light/dark) deve ser passado explicitamente pelo ThemeProvider em
 * tarefa futura. Por enquanto usamos 'system' (segue prefers-color-scheme),
 * permitindo que o smoke-test funcione antes do ThemeProvider existir.
 *
 * Tokens visuais herdam das CSS variables (`--popover`, `--border`, etc.)
 * via `classNames`, mantendo consistência com Shadcn/ui.
 */
export function Toaster({ ...props }: ToasterProps) {
  return (
    <SonnerToaster
      theme="system"
      className="toaster group"
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

// Re-export utilitário `toast` para uso direto em handlers.
export { toast } from 'sonner'
